<div class="terms-section-box rounded px-4 py-3">
  <div
    *ngIf="termsAndConditions; else defaultTemplate"
    class="terms-section-content text-start mb-3"
    [innerHtml]="termsAndConditions.BodyText | safeHtml"
  ></div>
  <ng-template #defaultTemplate>
    <ng-container [ngTemplateOutlet]="defaultTerms"></ng-container>
    <ng-container *ngIf="!defaultTerms"> {{ 'terms.default' | translate }}</ng-container>
  </ng-template>
</div>
